const configuredBaseUrl = import.meta.env?.VITE_LETS_PLAY_MEDIA_BASE_URL || ''
const APPROVED_MEDIA_HOST = 'privana-lets-play.s3.eu-west-2.amazonaws.com'

export function createGolfCelebrationMedia(baseUrl = configuredBaseUrl) {
  let base = ''
  try {
    const url = new URL(String(baseUrl).trim())
    if (url.protocol === 'https:' && url.hostname === APPROVED_MEDIA_HOST) base = url.href.replace(/\/+$/, '')
  } catch { /* An absent/invalid media setting deliberately selects the offline fallback. */ }
  const videoUrl = (filename) => base ? `${base}/${filename}` : ''

  return Object.freeze({
    birdie: Object.freeze({ title: 'BIRDIE', fallbackCopy: 'Nicely judged.', videoUrl: videoUrl('birdieclip.mp4'), objectFit: 'cover', objectPosition: 'center', scale: 1 }),
    eagle: Object.freeze({ title: 'EAGLE', fallbackCopy: 'Two better. Very tidy.', videoUrl: videoUrl('eagleclip.mp4'), objectFit: 'cover', objectPosition: 'center', scale: 1 }),
    albatross: Object.freeze({ title: 'ALBATROSS', fallbackCopy: 'You don’t see that every day.', videoUrl: videoUrl('albatrossclip.mp4'), objectFit: 'cover', objectPosition: 'center', scale: 1 }),
    hole_in_one: Object.freeze({ title: 'HOLE IN ONE', fallbackCopy: 'Straight in the history book.', videoUrl: videoUrl('holeinoneclip.mp4'), objectFit: 'cover', objectPosition: 'center', scale: 1 }),
  })
}

export const GOLF_CELEBRATION_MEDIA = createGolfCelebrationMedia()

let preloadedRoundId = null
let preloadedVideos = []

// Fetch the likely Birdie clip once per round; rare clips only fetch metadata until selected.
export function preloadGolfCelebrationMedia(roundId, media = GOLF_CELEBRATION_MEDIA) {
  if (!roundId || roundId === preloadedRoundId || typeof document === 'undefined') return
  preloadedRoundId = roundId
  preloadedVideos = Object.entries(media).flatMap(([kind, presentation]) => {
    if (!presentation.videoUrl) return
    const video = document.createElement('video')
    video.muted = true
    video.playsInline = true
    video.preload = kind === 'birdie' ? 'auto' : 'metadata'
    video.src = presentation.videoUrl
    return [video]
  })
}
